

























import { Component, Vue } from 'vue-property-decorator';

import { jqTHLink, repoLink, vueLink } from '@/constants/links';

@Component({
	name: 'Home'
})
export default class Home extends Vue {
	vueLink: string = vueLink;
	repoLink: string = repoLink;
	jqTHLink: string = jqTHLink;
}
